export interface UrlBlacklist {
    [url: string]: boolean;
}
